export const PRICE_LISTS = {
  BUTTON_LABEL: 'Add price list',
  DELETE: 'Delete price list?',
}

export const SUCCESS_PRICE_LISTS_UPDATE =
  'Your price lists have been successfully saved '
